import { useState } from 'react';
import { Link } from 'react-router-dom';
import { financecommerceApi } from '../../api/financecommerce';

export function GSTDashboardPage() {
  const [gstr1, setGstr1] = useState<unknown>(null);
  const [gstr3b, setGstr3b] = useState<unknown>(null);

  async function load() {
    setGstr1(await financecommerceApi.gstr1());
    setGstr3b(await financecommerceApi.gstr3b());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/finance" className="text-sm text-slate-600 hover:underline">← Finance hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">GST dashboard</h1>
      <button type="button" onClick={() => void load()} className="mt-4 rounded bg-slate-900 px-4 py-2 text-sm text-white">Load GSTR reports</button>
      {gstr1 != null && <pre className="mt-4 overflow-auto rounded border p-3 text-xs">{JSON.stringify(gstr1, null, 2)}</pre>}
      {gstr3b != null && <pre className="mt-4 overflow-auto rounded border p-3 text-xs">{JSON.stringify(gstr3b, null, 2)}</pre>}
    </div>
  );
}
